import axios from 'axios';
import * as types from '../constants/ActionTypes';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const RELATED_ARTICLE_URL = '/smarthelp/related-article';

function resetRelatedArticle() {
  return { type: types.RESET_RELATED_ARTICLE };
}

function requestRelatedArticle() {
  return {
    type: types.REQUEST_RELATED_ARTICLE,
    payload: undefined,
  };
}

function receiveRelatedArticle(responseData) {
  return {
    type: types.RECEIVE_RELATED_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveRelatedArticleError() {
  return {
    type: types.RECEIVE_RELATED_ARTICLE_ERROR,
    payload: undefined,
  };
}

function fetchRelatedArticle(topicName) {
  return (dispatch) => {
    dispatch(requestRelatedArticle());
    return axios.get(`${RELATED_ARTICLE_URL}?q=${topicName}`, {
      cancelToken: source.token,
    })
    .then(response => (
      dispatch(receiveRelatedArticle(response.data))
    ))
    .catch(() => (
      dispatch(receiveRelatedArticleError())
    ));
  };
}

function cancelRelatedArtilceRequest() {
  source.cancel('Related article request canceled.');
}

module.exports = {
  fetchRelatedArticle,
  cancelRelatedArtilceRequest,
  resetRelatedArticle,
};
